import { IApiSourceParams, IApiSourceResponse } from '@apis/client';
import axios, { AxiosResponse } from 'axios';
import ucLogin from './ucLogin';
import * as ErrorMessages from './ErrorMessages';
import { isCubeApp, systemCode } from '@helpers/Constants';
import Alert from '@widgets/Alert';
import ConfirmModal from '@components/ConfirmModal';
import OfflineHelp  from '@components/OfflineHelp';

import { showLoading, hideLoading } from '@widgets/Loading';

export interface IResponseResult<T = any> {
  statusCode: number;
  message: string;
  data: T;
}

interface IPostOptions {
  /** 忽略接口不可重复调用的限制 */
  ignoreRepeated?: boolean;
  /** 不展示loading */
  noLoading?: boolean;
  /** 请求出现错误时不展示提示消息 */
  noMessage?: boolean;
  btnEvent?: () => void;
}

const preventFetchRepeated: any = {};

type TApiKeys = keyof IApiSourceParams;
// 发起post请求
async function post<Action extends TApiKeys = TApiKeys>(
  action: Action,
  params: IApiSourceParams[Action],
  options?: IPostOptions,
): Promise<{
  statusCode: number;
  message: string;
  data: IApiSourceResponse[Action];
}> {
  // if (!options?.ignoreRepeated) {
  //   if (typeof preventFetchRepeated[action] !== 'undefined') {
  //     await Promise.reject('REPEAT_FETCH_REQUEST');
  //   }
  //   preventFetchRepeated[action] = 'fetching';
  // }
  if (!options?.noLoading) {
    showLoading();
  }
  const response: any = await Promise.race([
    new Promise(function(resolve, reject) {
      setTimeout(reject, 30000);
    }),
    axios
      .post<
        IApiSourceParams[Action],
        AxiosResponse<IResponseResult<IApiSourceResponse[Action]>>
      >(`${window.PUBLIC_URL}/api.json?action=${action}`, params, {
        headers: { 'Content-Type': 'application/json' },
      })
      .catch(e => {
        handlePost(action, '网络连接异常，请重试', options);
        throw new Error('ERROR_FETCH_REQUEST');
      }),
  ]);
  if (response.status === 200) {
    const result: IResponseResult = response.data;
    const isFailed = result.statusCode !== 200;
    if (
      ErrorMessages.extraHandlerCode.DEVICE_LOCKED === result.statusCode ||
      ErrorMessages.extraHandlerCode.DEVICE_OFFLINE === result.statusCode ||
      ErrorMessages.extraHandlerCode.DEVICE_FORBID === result.statusCode
    ) {
      if(ErrorMessages.extraHandlerCode.DEVICE_LOCKED === result.statusCode) {
        ConfirmModal.show({
          title: '设备已锁定',
          text: '设备插入的SIM卡不是服务商提供，因此设备已被锁定，解锁请插入服务商提供的SIM卡，并确认SIM卡可正常使用。',
          confirmBtnText: '我知道了',
        })
      }
      if(ErrorMessages.extraHandlerCode.DEVICE_FORBID === result.statusCode) {
        ConfirmModal.show({
          title: '设备已禁用',
          text: '设备已被服务商禁用，请联系服务商解除。',
          confirmBtnText: '我知道了',
        })
      }
      if(ErrorMessages.extraHandlerCode.DEVICE_OFFLINE === result.statusCode) {
        OfflineHelp.show();
      }
      hideLoading();
    } else {
      const errorMessage = isFailed ? ErrorMessages.get(action, result) : null;
      handlePost(action, errorMessage, options);
      if(!isCubeApp()) {
        if((response?.data?.statusCode === -505 && response?.data.message === '鉴权失败') || response?.data?.statusCode === 40106) {
          console.log(window.LOGIN_URL + `?system=${systemCode }&redirect_url=` + window.BASE_URL, 'redirect_url')
          setTimeout(() => {
            sessionStorage.setItem('fromSeewoUC', 'y');
            window.location.replace(window.LOGIN_URL + `?system=${systemCode }&redirect_url=` + encodeURIComponent(window.BASE_URL));
          }, 1000);
          return;
        }
      }
    }
    return isFailed ? await Promise.reject(result) : result;
  } else {
    console.log(action, 'action');
    handlePost(action, '接口请求异常，请重试', options);
    throw new Error('ERROR_BACKEND_INTERFACE');
  }
}

function handlePost(
  action: string,
  message: string | null,
  options: IPostOptions,
): void {
  if (!options?.noLoading) {
    hideLoading();
  }
  if (!options?.noMessage && typeof message === 'string') {
    let btnEventMap = {};
    if (options?.btnEvent) {
      btnEventMap = { btnEvent: options?.btnEvent };
    }
    Alert.show({
      title: message,
      ...btnEventMap,
    });
  }
  if (!options?.ignoreRepeated) {
    delete preventFetchRepeated[action];
  }
}

const Http = {
  post,
  ucLogin,
};

export default Http;
